import axios from "axios";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URI,

  headers: {
    "x-api-key": process.env.REACT_APP_API_KEY,
  },
});

axiosInstance.interceptors.request.use(
  function configuration(config) {
    const token =
      localStorage.getItem("ACCESS_TOKEN") ||
      localStorage.getItem("RESET_TOKEN");
    if (token) config.headers.authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
let isSessionExpired = false;
axiosInstance.interceptors.response.use(
  function (result) {
    return result;
  },
  function (error) {
    if (
      error.response &&
      error.response.data.code === 401 &&
      !isSessionExpired
    ) {
      isSessionExpired = true;
      localStorage.clear();
      toast.error("Your session has expired. Please log in again.");
      setTimeout(() => {
        window.location.href = "/";
      }, 3000);
    }
    if (error.response.data.code === 403) {
      toast.error(error.response.data.message);
    }
    if (error.response.data.code === 409) {
      toast.error(error.response.data.message);
    }
    return Promise.reject(console.log(error));
  }
);

export const GET = async (url, params) => {
  try {
    let result = await axiosInstance.get(url, { params: params });
    return result;
  } catch (error) {
    return error?.response;
  }
};

export const DELETE = async (url, params, data) => {
  try {
    let result = await axiosInstance.delete(url, { params, data });
    return result;
  } catch (error) {
    return error?.response;
  }
};

export const POST = async (url, body, options) => {
  try {
    let result = await axiosInstance.post(url, body, options);
    return result;
  } catch (error) {
    return error?.response;
  }
};

export const PUT = async (url, body, options) => {
  try {
    let result = await axiosInstance.put(url, body, options);
    return result;
  } catch (error) {
    return error?.response;
  }
};

export const PATCH = async (url, body, options) => {
  try {
    let result = await axiosInstance.patch(url, body, options);
    return result;
  } catch (error) {
    return error?.response;
  }
};

export { axiosInstance };
